import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Tooltip} from "antd";
import {ButtonRight} from "@dropDesk/presentation/components/inputs/input_with_border/button_top_one/styled";
import DropDeskIcon from "@dropDesk/storage/icons";

const ButtonTopOne = (
    {
        tooltipButtonRight,
        onClickButtonRight,
        disabledButtonRight,
        nameIconButtonRight,
        labelButtonRight
    }: {
        tooltipButtonRight?: string,
        onClickButtonRight?: () => void;
        disabledButtonRight?: boolean;
        nameIconButtonRight?: string;
        labelButtonRight?: string;
    }
) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    return (
        <Tooltip title={tooltipButtonRight ?? ''}>
            <div>
                <ButtonRight
                    onClick={(event) => {
                        event.preventDefault();
                        if (onClickButtonRight) {
                            onClickButtonRight();
                        }
                    }}
                    background={colors.buttonOnBackground}
                    letterColor={colors.text}
                    accent={colors.accent}
                    border={colors.border}
                    disabled={disabledButtonRight}
                >
                    {labelButtonRight ?? ''}
                    {nameIconButtonRight && <DropDeskIcon
                        icon={nameIconButtonRight}
                        color={colors.text}
                        size={10}
                        style={{
                            cursor: disabledButtonRight ? "no-drop" : "pointer",
                        }}
                    />}
                </ButtonRight></div>
        </Tooltip>
    )
}
export default ButtonTopOne;
